module.exports = __webpack_public_path__ + "img/tg-3.2325f761.png";